import { changeFilter } from "app/store/dashboard/patient_analytic/slice/patientAnalyticSlice";
import DateRangeFilter from "components/common/filters/daterange/DateRangeFilter";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DATE_FORMAT } from "static/date";
import { getFormattedDate } from "utils/date";

const PatientAnalyticDateFilter = () => {
  const { startDate, endDate } = useSelector((state) => state.patientAnalytic);
  const dispatch = useDispatch();

  return (
    <DateRangeFilter
      startDate={startDate}
      endDate={endDate}
      handleStartDate={(date) => {
        dispatch(
          changeFilter({
            type: "startDate",
            value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
          })
        );
      }}
      handleEndDate={(date) => {
        dispatch(
          changeFilter({
            type: "endDate",
            value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
          })
        );
      }}
    />
  );
};

export default PatientAnalyticDateFilter;
